/* eslint-disable class-methods-use-this */
export default class HandleToggle {
  constructor(elements) {
    this.triggers = elements;
    this.setDOMReferences();

    // eslint-disable-next-line prefer-arrow-callback
    document.body.addEventListener('makeTogglePassive', (event) => {
      this.update(event.detail.toggleId, 'passive');
    });
  }

  setDOMReferences() {
    for (let i = 0; i < this.triggers.length; i++) {
      const element = this.triggers[i];
      element.addEventListener('click', () => {
        const id = element.dataset.toggleId;
        let { state } = element.dataset;
        state = state === 'passive' ? 'active' : 'passive';
        this.update(id, state);
      });
    }
  }

  update(id, state) {
    const elements = document.querySelectorAll(`[data-toggle-id=${id}]`);
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      element.setAttribute('data-state', state);
    }
  }
}
